import React from 'react';
import { Box } from '@mui/material';

export function FooterStatic() {
  return (
    <>
      <Box
        component="footer"
        sx={{
          mt: 'auto',
          backgroundColor: 'background.paper',
        }}
      >
        <footer
          id="authFooter"
          className="footer-container authFooter fix-footer-at-bottom"
        >
          <div
            className="MuiGrid-root authFooter_container"
            id="authFooter_container"
          >
            <div id="footer-main-container">
              <ul className="footer-top-menu">
                <li id="footer-top-menu_li_id">
                  <a href="/contact-us">Contact Us</a>
                </li>
                <li id="footer-top-menu_li_id">
                  <a href="/bright-support">Support</a>
                </li>
              </ul>
              <hr className="footer-white-line" id="footer_white_line_hr"></hr>
              <div
                className="footer-bottom-section"
                id="footer_bottom_section_id"
              >
                <div
                  className="footer-bottom-first-section"
                  id="footer_bottom_first_section_id"
                >
                  <ul>
                    <li id="footer_bottom_first_section_ul_li_0">
                      <a
                        href="https://www.facebook.com/BrightMLS"
                        target="_blank"
                        aria-label="facebook"
                        rel="noreferrer"
                      >
                        <img
                          id="footer-facebook"
                          src="https://images.ctfassets.net/1g8q1frp41ix/35tLMSPCLNql5biAnpgkoz/74b76753c9a736fd230a16bbd3aa7cd0/Ellipse_40.png"
                          alt="facebook"
                        />{' '}
                      </a>
                    </li>
                    <li id="footer_bottom_first_section_ul_li_1">
                      <a
                        href="https://twitter.com/Bright_MLS"
                        target="_blank"
                        aria-label="twitter"
                        aria-invalid="true"
                        rel="noreferrer"
                      >
                        {' '}
                        <img
                          id="footer-twitter"
                          src="https://images.ctfassets.net/1g8q1frp41ix/4MiKmvGin9OQ34aKbjvM8c/ddb93c18c1cbbe5ea75fcf700cec8875/Ellipse_41.png"
                          alt="twitter"
                        />{' '}
                      </a>
                    </li>
                    <li id="footer_bottom_first_section_ul_li_2">
                      <a
                        href="https://www.linkedin.com/company/brightmls"
                        target="_blank"
                        aria-label="linkedin"
                        aria-invalid="true"
                        rel="noreferrer"
                      >
                        {' '}
                        <img
                          id="footer-linked-in"
                          src="https://images.ctfassets.net/1g8q1frp41ix/68izYmi8lvmq1X72YynIVz/d5e85d1def7ac9035f2c0fee571533a8/linked_in.png"
                          alt="linked in"
                        />{' '}
                      </a>
                    </li>
                    <li id="footer_bottom_first_section_ul_li_3">
                      <a
                        href="https://www.youtube.com/c/BrightMLS"
                        target="_blank"
                        aria-label="youtube"
                        rel="noreferrer"
                      >
                        {' '}
                        <img
                          id="footer-youtube"
                          src="https://images.ctfassets.net/1g8q1frp41ix/2KO1f3d1Hmln8l8jiHaCeC/521a761fdb66e454c9bcd5698ce3e6db/you_tube.png"
                          alt="youTube"
                        />{' '}
                      </a>
                    </li>
                    <li id="footer_bottom_first_section_ul_li_4">
                      <a
                        href="https://www.instagram.com/brightmls"
                        target="_blank"
                        aria-label="instagram"
                        aria-invalid="true"
                        rel="noreferrer"
                      >
                        {' '}
                        <img
                          id="footer-inst-a-gram"
                          src="https://images.ctfassets.net/1g8q1frp41ix/6cXhUHG7NsXpSZmafrlzX9/498fc61fc7a993764971f6dcefb8d4f8/insta.png"
                          alt="instAGram"
                        />{' '}
                      </a>
                    </li>
                  </ul>
                  <div id="footer_bottom_first_section_bright_home">
                    <a
                      href="https://www.nestfully.com/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Nestfully.com
                    </a>
                  </div>
                </div>
              </div>
              <ul className="footer-bottom-second-section">
                <li id="footer_bottom_second_section_ul_li_0">
                  <a href="/copyright">Copyright notice</a>
                </li>
                <li id="footer_bottom_second_section_ul_li_1">
                  <a href="/terms">Terms of use</a>
                </li>
                <li id="footer_bottom_second_section_ul_li_2">
                  <a href="/privacy">Privacy Statement</a>
                </li>
                <li id="footer_bottom_second_section_ul_li_3">
                  <a href="/accessibility">Accessibility</a>
                </li>
                <li id="footer_bottom_second_section_ul_li_4">
                  <a href="/subscription-agreement">Subscriber Agreement</a>
                </li>
              </ul>
              <div
                className="footer-copy-right-section"
                id="footer_copy_right_section"
              >
                <span id="footer_copy_right_text">
                  ©2025 Bright MLS All Rights Reserved.
                </span>
              </div>
            </div>
          </div>
        </footer>
      </Box>
    </>
  );
}
